import { createContext, useContext } from 'react';

export interface RachelRegionsContextValue {
  footerSlotNode: HTMLDivElement | null;
  setFooterSlotNode: (node: HTMLDivElement | null) => void;
}

export const RachelRegionsContext = createContext<RachelRegionsContextValue | null>(null);

export const useRachelRegionsContext = (): RachelRegionsContextValue => {
  const context = useContext(RachelRegionsContext);
  if (!context) {
    throw new Error('useRachelRegionsContext must be used within a RachelChatProvider');
  }
  return context;
};
